export const MAX_PAYOUT_AMOUNT_PAWN_CONTINUE_USING = 20_000
